

import Vue from 'vue';
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";

import LMModule from "@/components/locker/modules/LMModule.vue";

@Component({
  name: 'LMCreateModuleDialog',
  components: {
    LMModule,
  }
})
export default class WebhookLogErrorDialog extends Vue {
  @Prop()
  protected show: boolean = false;
  protected subscribes: object = {};

  protected onHide() {
    this.$emit('update:show', false);
  }
}

